/**
 * Product Type IDs enum
 * Based on the product type IDs used throughout the system
 */
export var ProductTypeId;
(function (ProductTypeId) {
    /** Timpris - Hourly pricing based on Nordpool spot price */
    ProductTypeId[ProductTypeId["TIMPRIS"] = 132] = "TIMPRIS";
    /** Kvartspris - Quarter-hour pricing */
    ProductTypeId[ProductTypeId["KVARTSPRIS"] = 172] = "KVARTSPRIS";
    /** Fast - Fixed price products */
    ProductTypeId[ProductTypeId["FAST"] = 2] = "FAST";
    /** Rörligt - Variable price products */
    ProductTypeId[ProductTypeId["RORLIGT"] = 1] = "RORLIGT";
    /** Tillägg - Add-on products */
    ProductTypeId[ProductTypeId["TILLAGG"] = 4] = "TILLAGG";
})(ProductTypeId || (ProductTypeId = {}));
